<div id="createNewsCategory" class="col-md-8 offset-md-2">
  <h1 id="pageHeadline">News Kategorie erstellen</h1>

  <form [formGroup]="form" (ngSubmit)="createNewsCategory()" class="d-flex flex-column">
    <mat-form-field appearance="fill">
      <mat-label>Titel der Kategorie</mat-label>
      <input matInput type="text" placeholder="Titel der Kategorie" formControlName="categoryName" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Adresse des Feeds</mat-label>
      <input matInput type="text" placeholder="URL" formControlName="feedUrl" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Fakultät</mat-label>
      <input matInput type="text" placeholder="Fakultät ID" formControlName="facultyInput" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Format wählen</mat-label>
      <mat-select formControlName="feedFormat">
        <mat-option value="RSS">RSS</mat-option>
        <mat-option value="JSON">JSON</mat-option>
      </mat-select>
    </mat-form-field>

    <div>
      <mat-label>Bild wählen*</mat-label>
      <div class="d-flex align-items-center mb-1">
        <mat-icon>warning</mat-icon>
        <span>Bild ist wegen der Konfiguration des Backends required!</span>
      </div>
      <input type="file" id="categoryFileSelect" (change)="handleFileSelect($event)" />
    </div>

    <div *ngIf="bildBase64textString" class="text-center categoryImageThumbnail">
      <img src="data:image/png;base64,{{ bildBase64textString }}" class="img-thumbnail w-25" alt="Bild Kategorie" />
    </div>

    <div class="d-flex justify-content-start mt-2 mb-2">
      <a mat-stroked-button role="button" class="btn btn-danger mr-2" (click)="askForConfirmation()">Abbrechen</a>
      <button
        mat-flat-button
        class="btn btn-success"
        type="submit"
        [disabled]="form.invalid || bildBase64textString === ''"
      >
        Anlegen
      </button>
    </div>
  </form>
</div>
